import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { applyDocumentLang, getLang } from "../i18n/lang";
import { PublicPiece } from "./PublicPiece";
import "../styles/base.css";

/*
 * The customer page a printed QR tag opens, in any phone browser. No Telegram,
 * no router, no query cache: one fetch, one screen. Theme follows the system.
 */
const dark = window.matchMedia("(prefers-color-scheme: dark)");
const applyTheme = () => {
  document.documentElement.dataset.theme = dark.matches ? "dark" : "light";
};
applyTheme();
dark.addEventListener("change", applyTheme);
applyDocumentLang(getLang());

const code = location.pathname.match(/^\/p\/([A-Za-z0-9_-]{1,32})\/?$/)?.[1] ?? null;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PublicPiece code={code} />
  </StrictMode>,
);
